<template>
  <div id="app">
    <router-view></router-view>
    <Footer />
    <button
      v-if="showContactButton"
      class="floating-service-btn"
      type="button"
      @click="contactService"
    >
      <span class="floating-service-btn__text">{{ $t('common.contact_service') }}</span>
    </button>
  </div>
</template>

<script>
import Footer from './common/Footer'

export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status: 0
    };
  },
  computed: {
    showContactButton() {
      const hiddenRoutes = ['ServiceOnline', 'ServicePage'];
      return !hiddenRoutes.includes(this.$route.name);
    }
  },
  methods: {
    getBaseInfo() {
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        const publicRoutes = ['login', 'register'];
        if (!localStorage.getItem('token') && !publicRoutes.includes(this.$route.name)) {
          this.$router.push({ path: '/Login' })
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    },
    contactService() {
      const service = this.$store.getters.getBaseInfo || {};
      if (service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu;
        return;
      }
      this.$toast(this.$t('common.service_unavailable'));
    }
  },
  created() {
    this.getBaseInfo();
  }
}
</script>

<style>
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 230px;
}

body .van-toast .van-toast__icon {
  font-size: 50px;
}

*, :after, :before {
  box-sizing: border-box;
}

.floating-service-btn {
  position: fixed;
  right: 24px;
  bottom: 140px;
  z-index: 9999;
  width: 112px;
  height: 112px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff8a5b, #ff5f6d);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  box-shadow: 0 10px 24px rgba(255, 95, 109, 0.32);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.floating-service-btn__text {
  display: inline-block;
  line-height: 1.2;
  font-size: 22px;
  font-weight: 700;
}
</style>
